import React, { useState, useEffect } from "react";
import { Text, StyleSheet, View, TouchableOpacity, Platform } from "react-native";

import RoundCheckbox from "../../common/RoundCheckbox";
import Icons from "../../common/icons";
import TutorialsHelper from "../../tutorials/TutorialsHelper";
import AppTheme from "../../AppTheme";
import cardStyles from "../cards/cardStyles";
import CloseIcon from "../../common/dialog/CloseIcon";
import {
  getStorageItem,
  getStorageKey,
  setStorageItem,
} from "../../../../helpers/utils";

export default function TutorialsCard({ controller }) {
  const [itemsList, setItemsList] = useState([]);
  const [showCard, setShowCard] = useState(false);
  const [progress, setProgress] = useState(0);
  const [title, setTitle] = useState("");

  useEffect(() => {
    getStorageItem(getStorageKey(controller, "card:tutorial")).then((data) => {
      if (data && !data.show) {
        return;
      }

      const { is_enabled, has_scheduled_call, tutorials = {} } =
        controller.state?.settings || {};

      // Show card for admins
      const { show_tutorials_card } =
        controller.state?.settings?.testing_preferences || {};

      const { goals, reflection, track } = tutorials;

      // Show card if at least one tutorial wasn't completed
      setShowCard(show_tutorials_card || !reflection || !goals || !track);

      const options = is_enabled
        ? TutorialsHelper.getActiveUserOptions({
            has_scheduled_call,
            ...tutorials,
          })
        : TutorialsHelper.tutorialsCardOptions({
            has_scheduled_call,
            ...tutorials,
          });

      const optionsCount = options.length;
      if (optionsCount > 0) {
        const completed = options.filter((o) => o.isComplete).length;
        const pg = (100 * completed) / optionsCount;
        setProgress(pg);

        setTitle(
          completed == optionsCount
            ? "Setup Complete!"
            : `Setup ${pg}% Complete!`,
        );
      }

      if (is_enabled) setTitle("Check out what’s new!");

      setItemsList(options);
    });
  }, [controller.state?.settings]);

  const hideCard = () => {
    setShowCard(false);
    setStorageItem(getStorageKey(controller, "card:tutorial"), {
      show: false,
    });
  };

  return !showCard ? null : (
    <View style={cardStyles.container}>
      <View style={[cardStyles.card, { minHeight: 90 }]}>
        <CloseIcon onPress={() => hideCard()} style={cardStyles.closeButton} />
        <View style={cardStyles.header}>
          <View style={cardStyles.headerInfo}>
            <Text style={cardStyles.title}>{title}</Text>
            <View style={styles.progress}>
              <View style={[styles.complete, { width: `${progress}%` }]} />
            </View>
          </View>
        </View>

        <View style={[styles.container]}>
          <View style={{ flex: 1 }}>
            {itemsList.map((b, index) => (
              <TouchableOpacity
                key={index}
                style={styles.row}
                onPress={() => TutorialsHelper.onTutorialClicked(controller, b)}
              >
                {b.isComplete ? (
                  <RoundCheckbox
                    size={22}
                    checked={true}
                    style={{ width: 22, height: 22 }}
                  />
                ) : (
                  <View style={[styles.number]}>
                    <Text style={styles.numberText}>{index + 1}</Text>
                  </View>
                )}

                <Text
                  style={[
                    styles.tutorialText,
                    b.isComplete ? styles.textComplete : {},
                  ]}
                >
                  {b.name}
                </Text>

                {!b.isComplete ? (
                  <Icons.ArrowRight
                    fillColor={AppTheme.DEFAULT_COLOR}
                    onPress={() =>
                      TutorialsHelper.onTutorialClicked(controller, b, true)
                    }
                    style={{
                      width: 22,
                      height: 22,
                    }}
                  />
                ) : null}
              </TouchableOpacity>
            ))}
          </View>
        </View>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    flexDirection: "row",
    paddingHorizontal: 6,
    marginTop: 16,
  },
  row: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    marginBottom: 14,
  },
  number: {
    width: 22,
    height: 22,
    borderRadius: 22,
    borderWidth: 1,
    borderColor: AppTheme.DEFAULT_COLOR,
    justifyContent: "center",
    alignItems: "center",
    marginRight: 8,
  },
  numberText: {
    fontFamily:  Platform.select({ default: "Montserrat", android: "Montserrat-SemiBold" }),
    fontWeight: "600",
    fontSize: 12,
    lineHeight: 15,
    letterSpacing: 0.175,
    color: AppTheme.DEFAULT_COLOR,
  },
  tutorialText: {
    fontFamily:  Platform.select({ default: "Montserrat", android: "Montserrat-SemiBold" }),
    fontWeight: "600",
    fontSize: 12,
    lineHeight: 15,
    letterSpacing: 0.175,
    color: AppTheme.DEFAULT_COLOR,
    marginLeft: 8,
  },
  textComplete: {
    opacity: 0.6,
    color: AppTheme.almostBlack,
    textDecorationLine: "line-through",
  },

  progress: {
    position: "relative",
    height: 4,
    width: "100%",
    backgroundColor: "#C0C9D0",
    borderRadius: 3,
    marginTop: 8,
  },
  complete: {
    position: "absolute",
    left: 0,
    top: 0,
    height: 4,
    width: "100%",
    backgroundColor: AppTheme.DEFAULT_COLOR,
    borderRadius: 3,
  },
});
